import styles from "./customer_photo.module.css";

const API_BASE = process.env.REACT_APP_API_URL;

const CustomerPhoto = ({ customer }) => {
  const img_base_url = API_BASE;
  const initialName = customer?.bill_to_name
    ?.split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();

  return customer?.logo ? (
    <img
      className={styles.img}
      src={img_base_url + customer?.logo}
      alt="customer_logo"
    />
  ) : (
    <div className={`${styles.img} ${styles.nameImg}`}>
      <p>{initialName}</p>
    </div>
  );
};

export default CustomerPhoto;
